import { FilterValue } from '@src/design-system/filter-new';
import type { TRenderSelectedValuesCtx } from '../../types/filter-config';
import leadStatusApi from '@src/features/leads/services/lead-status-api';
import { entityFilterIds } from '../../helpers/filter-none';

const SingleValue = ({ id }: { id: string | number }) => {
  const { data: status } = leadStatusApi.useFetchOne({ id });
  return <FilterValue>{status?.name}</FilterValue>;
};

export function LeadStatusFilterSelectedValues({
  filter,
}: TRenderSelectedValuesCtx) {
  return entityFilterIds(filter.value).map((v) => (
    <SingleValue
      key={v}
      id={v}
    />
  ));
}
